import { TagStruct } from "src/app/shared/components/tag/tag.struct";
import { PrescriptionSolution } from "../../models/pharmacy/prescription-solution.model";
import { MaterialItemKitRequests } from "../../requests/pharmacy/request-material.request";
import { PrescriptionSolutionCheckStruct } from "./prescription-solution-check.struct";
import { PrescriptionSolutionMedicineStruct } from "./prescription-solution-medicine.struct";

export class PrescriptionSolutionStruct {
    public prescriptionSolution: PrescriptionSolution = new PrescriptionSolution();

    public listSolutionMedicine: PrescriptionSolutionMedicineStruct[] = [];
    public listSolutionCheck: PrescriptionSolutionCheckStruct[] = [];
    public listMaterialItemKitRequests: MaterialItemKitRequests[] = [];
    
    public idEpisode: number;
    public idNextPrescriptionSolutionCheck : number;
    public idRoom: number;
    public idMultiProfessionalCare: number;
    public idMedicalCare: number;
    public idPrescriptionStatus: number;
    public idMedicalCareSuspended: number;
    public idUserNurseSuspended: number;
    public frequencyValue: number;
    public subFrequencyValue: number;
        
    public lookupAdministrationLocationName: string;
    public usage: string;
    public administrationTypeName: string;
    public presentationName: string;
    public frequencyName: string;
    public treatmentPeriodName: string;
    public doseToAdministeredName: string;
    public dilutionName: string;
    public subFrequencyName: string;
    public dilutionUnitName: string;
    public measurementUnitName: string;
    public roomLocation: string;
    public medicNameSuspended: string;
    public nurseNameSuspended: string;
    public motiveSuspended: string;
    
    public canSuspend: boolean;

    //variáveis somente para o front
    public idSolutionStatus: number;
    public solutionStatus: string;
    public isChecked: boolean = false;
    public hasReport: boolean = false;
    public selectForDispensing: boolean = false;
    public prescriptionChecked: boolean = false;
    public tempCheck: boolean;

    public listSelectedIdKit: number[] = [];
}